import { BuildingIncidents } from "../../../Molecules/BuildingDetails/BuildingDetail/BuildingIncidents/BuildingIncidents";
import { DigitalTwinPage } from "../../../Molecules/BuildingDetails/BuildingDetail/Digital Twin/DigitalTwin";
import { ItemDetail } from "../../../Molecules/WeatherServiceDetils/ItemDetail";

export const RegisteryGlobalSubTabs = [
  {
    name: "Overview",
    label: "overview",
    path: "overview",
    subTabsPath: ["details", "incidents", "digital-twin"],
    submenus: null,
    component: [ItemDetail, BuildingIncidents, DigitalTwinPage],
    buttons: ['Details', 'Incidents', 'Digital Twin']
  }
];